"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDealLabel = exports.dealLabelTypes = void 0;
var _common = require("../../common");
const dealLabelTypes = exports.dealLabelTypes = new Set([_common.NEW, _common.NEW_EDITION, _common.NEW_EDITION_AVAILABLE, _common.OFFER, _common.SUPER_DEAL]);
const isDealLabel = label =>
// Type casting used so that there can be type checking in DEAL_LABEL_TYPES and yet it can
// be used for checking whether label has type DealLabelType.
dealLabelTypes.has(label ?? '');
exports.isDealLabel = isDealLabel;
